import { Branch } from '../base/branch';
import { User } from './user';

export class Group extends Branch {
    static _type: string = 'Group';

    i_group: true = true;

    override load(source?: any): void {
        this.copy(source);

        if (source) {
            const { nodes, branches } = source;

            nodes?.forEach((node: any) => {
                this.nodes.push(new User(node));
            });

            branches?.forEach((branch: any) => {
                this.branches.push(new Group(branch));
            });
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Group;
    }
}
